export const SET_TRANSFER_TYPE_DROPDOWN = "SET_TRANSFER_TYPE_DROPDOWN";
export const GET_TRANSFER_TYPE_DROPDOWN = "GET_TRANSFER_TYPE_DROPDOWN";
export const GET_DIVISION_DROPDOWN= 'GET_DIVISION_DROPDOWN'
export const SET_DIVISION_DROPDOWN= 'SET_DIVISION_DROPDOWN'
export const GET_COSTCENTER_DROPDOWN = 'GET_COSTCENTER_DROPDOWN'
export const SET_COSTCENTER_DROPDOWN = 'SET_COSTCENTER_DROPDOWN'
export const SET_ASSET_INFO_STEPPER_DATA = "SET_ASSET_INFO_STEPPER_DATA";
export const GET_ASSET_INFO_STEPPER_DATA = "GET_ASSET_INFO_STEPPER_DATA";